import styled from '@emotion/styled';

export const Page = styled.div`
    .ag-header-cell.center-cell > .ag-header-cell-comp-wrapper > .MuiStack-root,
    .ag-cell.center-cell > .MuiStack-root {
        align-self: center;
    }
`;
